// Angular
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
// Libs
import { ToastrService } from 'ngx-toastr';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
// Constants
import { AddressType } from '@core/enums/address-type.enum';
// Models
import { IError } from '@core/models-v2/error/error.interface';
// Services
import { SessionService } from '@core/services-v2/session/session.service';
import { CustomerAddressApiService } from '@core/services-v2/customer-address/customer-address-api.service';
import { GeolocationApiService } from '@core/services-v2/geolocation/geolocation-api.service';
import { ICity } from '@core/services-v2/geolocation/models/city.interface';
import { DireccionMap } from '../map/map.component';
import { CustomerContactApiService } from '@core/services-v2/customer-contact/customer-contact-api.service';
import { environment } from '@env/environment';
import { AddContactModalComponent } from '../add-contact-modal/add-contact-modal.component';

import { IContactPosition } from '@core/models-v2/customer/contact-position.interface';
import { IConfig } from '@core/config/config.interface';
import { ConfigService } from '@core/config/config.service';
import { CustomerContactService } from '@core/services-v2/customer-contact.service';
import { STREET_TYPES } from '@core/constants/street-type-es.constant';

@Component({
  selector: 'app-address-modal',
  templateUrl: './address-modal.component.html',
  styleUrls: ['./address-modal.component.scss'],
})
export class AddressModalComponent implements OnInit {
  @Input() modalAddressRef!: BsModalRef;
  @Output() respuesta = new EventEmitter<any>();

  cargos: IContactPosition[] = [];
  selectedPhoneCode!: string;
  config: IConfig;
  country = environment.country;

  comunas!: any[];
  cities!: ICity[];
  localidades!: any[];
  formDireccion!: FormGroup;
  tienda: DireccionMap | null;
  // tienda: any;
  coleccionComuna!: any[];
  autocompletado = true;
  loadingForm = false;

  //variable Perú
  departamento: any;
  provincia: any;
  distrito: any;
  codigoDistrito: string = '';

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    // Services V2
    private readonly sessionService: SessionService,
    private readonly customerAddressService: CustomerAddressApiService,
    private readonly geolocationApiService: GeolocationApiService,
    private readonly customerContactApiService: CustomerContactApiService,
    private readonly configService: ConfigService,
    private readonly customerContactService: CustomerContactService,
    private modalService: BsModalService
  ) {
    this.buildForm();
    this.tienda = null;
    this.config = this.configService.getConfig();
    this.selectedPhoneCode = this.config.phoneCodes.mobile.code;
  }

  abrirModalContacto(): void {
    if (this.country !== 'es') {
      return;
    }

    const modalRef: BsModalRef = this.modalService.show(
      AddContactModalComponent,
      {
        class: 'modal-lg',
      }
    );

    const comp = modalRef.content as AddContactModalComponent;
    comp.modalAddContactRef = modalRef;

    const sub = comp.respuesta.subscribe((ok: boolean) => {
      sub.unsubscribe();
      if (ok) {
        this.agregarDireccion();
      }
    });
  }

  private buildDireccionPayload() {
    const {
      calle,
      numero,
      localizacion,
      provincia,
      latitud,
      longitud,
      referencia,
      streetType,
      codigoPostal,
    } = this.formDireccion.value;

    const usuario = this.sessionService.getSession();

    return {
      documentId: usuario.documentId,
      addressType: AddressType.DELIVERY,
      number: numero.toString(),
      street: `${calle}`,
      streetType: `${streetType ? streetType + ' ' : ''}`,
      city: localizacion,
      province: provincia,
      region: provincia,
      location: '-',
      latitude: latitud,
      longitude: longitud,
      departmentOrHouse: '',
      reference: referencia,
      postalCode: codigoPostal,
    };
  }

  soloNumeros(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  streetTypes = STREET_TYPES;

  private buildForm(): void {
    this.formDireccion = this.fb.group({
      calle: [null, Validators.required],
      depto: [null],
      numero: [null, Validators.required],
      comuna: [
        this.country === 'cl' ? null : '',
        this.country === 'cl' ? Validators.required : [],
      ],
      provincia: [
        this.country === 'es' ? null : '',
        this.country === 'es' ? Validators.required : [],
      ],
      localizacion: [
        this.country === 'es' ? null : '',
        this.country === 'es' ? Validators.required : [],
      ],
      latitud: [null],
      longitud: [null],
      referencia: [null],

      streetType: [
        this.country === 'es' ? null : '',
        this.country === 'es' ? Validators.required : [],
      ],
      codigoPostal: [
        this.country === 'es' ? null : '',
        this.country === 'es' ? Validators.required : [],
      ],
      contactRut: [
        '',
        this.country === 'es'
          ? [Validators.required, Validators.maxLength(9)]
          : [],
      ],
      cargo: [null],
      nombre: [null, this.country === 'es' ? Validators.required : []],
      apellido: [null, this.country === 'es' ? Validators.required : []],
      telefono: [null, this.country === 'es' ? Validators.required : []],
      email: [
        '',
        this.country === 'es' ? [Validators.required, Validators.email] : [],
      ],
    });
  }

  ngOnInit(): void {
    this.getCities();
    if (this.country === 'pe') this.getDepartamento();
    if (this.country === 'es') this.getCargos();
  }

  getCargos() {
    this.customerContactService.getPositions().subscribe((response) => {
      this.cargos = response;
    });
  }

  selectFono(tipo: string) {
    this.selectedPhoneCode = tipo;
    const ctrl = this.formDireccion.get('telefono');
    if (!ctrl) return;
    if (tipo === this.config.phoneCodes.mobile.code) {
      ctrl.setValidators([
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(8),
      ]);
    } else {
      ctrl.setValidators([
        Validators.required,
        Validators.minLength(9),
        Validators.maxLength(9),
      ]);
    }
    ctrl.updateValueAndValidity();
  }

  nifValidator(ctrl: AbstractControl): ValidationErrors | null {
    const nif: string = (ctrl.value || '').toUpperCase().trim();
    if (!/^\d{8}[A-Z]$/.test(nif)) {
      return { invalidNif: true };
    }
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const idx = parseInt(nif.slice(0, 8), 10) % 23;
    return letters[idx] === nif[8] ? null : { invalidNif: true };
  }

  onNifBlur() {
    const ctrl = this.formDireccion.get('contactRut');
    if (ctrl) ctrl.markAsTouched();
  }

  noCharNIF(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
    this.formDireccion.get('contactRut')?.setValue(input.value);
  }

  validateNIF(): boolean {
    const rutControl = this.formDireccion.get('contactRut');
    const nif = rutControl?.value?.toUpperCase().trim();
    if (!nif || !/^\d{8}[A-Z]$/.test(nif)) return false;
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    return letters[parseInt(nif.slice(0, 8), 10) % 23] === nif[8];
  }

  set_direccion(data: any[]) {
    // this.clearAddress();

    const regionLongName = this.getAddressData(
      data[0],
      'administrative_area_level_1'
    );
    const regionShortName = data[0].find((comp: any) =>
      comp.types.includes('administrative_area_level_1')
    )?.short_name;

    const buscar = this.getAddressData(data[0], 'locality').toUpperCase();

    const existe = this.cities.filter((item) => item.city == buscar);

    //seteo direccion Chile
    if (this.country === 'cl') {
      if (existe.length) {
        this.formDireccion.controls['comuna'].setValue(
          this.getCityId(this.getAddressData(data[0], 'locality')) || null
        );
      } else {
        this.formDireccion.controls['comuna'].setValue(
          this.getCityId(
            this.getAddressData(data[0], 'administrative_area_level_3')
          ) || null
        );
      }
    }

    if (this.country === 'es') {
      const tipoViaCompleta = this.getAddressData(data[0], 'route');
      const primerPalabra = tipoViaCompleta?.split(' ')[0]?.trim();

      console.log('Tipo vía completa:', tipoViaCompleta);
      console.log('Primer palabra:', primerPalabra);

      const tipoViaNormalizado = this.streetTypes.find(
        (tipo) => tipo.label.toLowerCase() === primerPalabra?.toLowerCase()
      );
      this.formDireccion.controls['streetType'].setValue(
        tipoViaNormalizado?.value || null
      );
      console.log('Tipo vía normalizado:', tipoViaNormalizado);

      this.formDireccion.controls['provincia'].setValue(
        this.getAddressData(data[0], 'administrative_area_level_2') || ''
      );
      this.formDireccion.controls['localizacion'].setValue(
        this.getAddressData(data[0], 'locality') || ''
      );
      this.formDireccion.controls['codigoPostal'].setValue(
        this.getAddressData(data[0], 'postal_code') || ''
      );
    }

    console.log('Asignando Calle:', this.getAddressData(data[0], 'route'));
    this.formDireccion.controls['calle'].setValue(
      this.getAddressData(data[0], 'route')
    );
    this.getAddressData(data[0], 'street_number')
      ? this.formDireccion.controls['numero'].setValue(
          this.getAddressData(data[0], 'street_number')
        )
      : this.formDireccion.controls['numero'].setErrors({ completar: true });

    console.log('Coordenadas:', data[1]);
    this.formDireccion.controls['latitud'].setValue(data[1].lat);
    this.formDireccion.controls['longitud'].setValue(data[1].lng);

    console.log('Formulario actualizado:', this.formDireccion.value);
    this.obtenerLocalidades({
      id: this.formDireccion.controls['comuna'].value,
    });

    this.cargarDireccion();
  }

  getAddressData(address_components: any[], tipo: string) {
    let value = '';

    address_components.forEach((element: any) => {
      if (element.types[0] == tipo) {
        value = element.long_name;
        return;
      }
    });
    return value;
  }

  findComuna(nombre: string) {
    if (nombre != '') {
      nombre = this.quitarAcentos(nombre);

      var result = this.comunas.find(
        (data) => this.quitarAcentos(data.value) === nombre
      );

      if (result && result.id) {
        this.obtenerLocalidades(result);
        this.findComunaLocalizacion(result.value);
        return result.id;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  /**
   * Obtener id de una ciudad.
   * @param city
   * @returns
   */
  private getCityId(city: string): string {
    if (!city) return '';

    city = this.quitarAcentos(city);
    const result = this.cities.find(
      (item) => this.quitarAcentos(item.city) === city
    );

    if (result && result.id) {
      this.obtenerLocalidades(result);
      this.findComunaLocalizacion(result.city);
      return result.id;
    } else {
      return '';
    }
  }

  findComunaLocalizacion(nombre: string) {
    if (nombre != '') {
      nombre = this.quitarAcentos(nombre);

      var result = this.localidades.find(
        (data) => this.quitarAcentos(data.location) === nombre
      );

      if (result && result.location) {
        this.formDireccion.controls['localizacion'].setValue(result.location);
      }
    }
  }

  quitarAcentos(cadena: string) {
    // Definimos los caracteres que queremos eliminar
    var specialChars = '!@#$^&%*()+=-[]/{}|:<>?,.';

    // Los eliminamos todos
    for (var i = 0; i < specialChars.length; i++) {
      cadena = cadena.replace(new RegExp('\\' + specialChars[i], 'gi'), '');
    }

    // Lo queremos devolver limpio en minusculas
    cadena = cadena.toLowerCase();

    // Quitamos espacios y los sustituimos por _ porque nos gusta mas asi
    cadena = cadena.replace(/ /g, '_');

    // Quitamos acentos y "ñ". Fijate en que va sin comillas el primer parametro
    cadena = cadena.replace(/á/gi, 'a');
    cadena = cadena.replace(/é/gi, 'e');
    cadena = cadena.replace(/í/gi, 'i');
    cadena = cadena.replace(/ó/gi, 'o');
    cadena = cadena.replace(/ú/gi, 'u');
    cadena = cadena.replace(/ñ/gi, 'n');

    return cadena;
  }

  /*async agregarDireccion() {
    this.loadingForm = true;
    const {
      calle,
      depto,
      numero,
      comuna,
      localizacion,
      latitud,
      longitud,
      referencia,
    } = this.formDireccion.value;
    const comunaArr = comuna.split('@');
    const usuario = this.sessionService.getSession(); //: Usuario = this.root.getDataSesionUsuario();

    const direccion = {
      documentId: usuario.documentId,
      addressType: AddressType.DELIVERY,
      region: comunaArr[2],
      city: comunaArr[0],
      number: numero.toString(),
      province: comunaArr[1],
      street: calle,
      //location: localizacion,
      location: '-',
      latitude: latitud,
      longitude: longitud,
      departmentOrHouse: depto || '',
      reference: referencia,
    };

    this.customerAddressService.createAddress(direccion).subscribe({
      next: (_) => {
        this.toastr.success('Se agrego con exito la dirección');
        this.respuesta.emit(true);
        this.modalAddressRef.hide();
        this.loadingForm = false;
      },
      error: (err: IError) => {
        this.toastr.error('No se logro agregar la direccion');
        this.respuesta.emit(false);
        this.loadingForm = false;
      },
    });
  }*/

  async agregarDireccion() {
    if (this.country === 'es' && !this.validateNIF()) {
      this.toastr.error('El NIF ingresado no es válido');
      return;
    }

    if (this.country === 'es' && this.formDireccion.get('email')?.invalid) {
      this.toastr.error('Debes ingresar un e‑mail de contacto válido');
      return;
    }

    this.loadingForm = true;

    const {
      calle,
      depto,
      numero,
      comuna,
      localizacion,
      latitud,
      longitud,
      referencia,
      streetType,
      codigoPostal,
      provincia,
    } = this.formDireccion.value;

    const usuario = this.sessionService.getSession();

    let direccion: any = {
      documentId: usuario.documentId,
      addressType: AddressType.DELIVERY,
      number: numero.toString(),
      street: `${calle}`,
      streetType: streetType || '',
      location: '-',
      latitude: latitud,
      longitude: longitud,
      departmentOrHouse: depto || '',
      reference: referencia,
      postalCode: codigoPostal || null,
    };

    if (this.country === 'cl' && comuna) {
      const comunaArr = comuna.split('@');
      direccion.city = comunaArr[0];
      direccion.province = comunaArr[1];
      direccion.region = comunaArr[2];
    } else if (this.country === 'es') {
      direccion.city = localizacion || '';
      direccion.province = provincia || '';
      direccion.region = provincia || '';
    } else if (this.country === 'pe') {
      direccion.city = comuna || '';
      direccion.province = provincia || '';
      direccion.region = this.formDireccion.get('depto')?.value || '';
    }

    const v = this.formDireccion.value;

    if (this.country === 'es') {
      direccion.contact = {
        documentId: v.contactRut,
        name: v.nombre,
        lastName: v.apellido,
        email: v.email,
        phone: this.selectedPhoneCode + v.telefono,
      };
    }

    this.customerAddressService.createAddress(direccion).subscribe({
      next: (_) => {
        this.toastr.success('Se agregó con éxito la dirección');
        this.respuesta.emit(true);
        this.modalAddressRef.hide();
        this.loadingForm = false;
      },
      error: (err: IError) => {
        this.toastr.error('No se logró agregar la dirección');
        this.respuesta.emit(false);
        this.loadingForm = false;
      },
    });
  }

  cargarDireccion() {
    this.tienda = null;

    if (!this.formDireccion.valid) {
      return;
    }
    const { calle, numero, comuna, localizacion } = this.formDireccion.value;
    const comunaArr = comuna.split('@');

    this.tienda = {
      direccion: `${calle} ${numero}`,
      zona: `${comunaArr[0]} ${localizacion}`,
    };
  }

  /**
   * Obtener ciudades.
   */
  private getCities(): void {
    this.geolocationApiService.getAdministrativeAreasLevel2().subscribe({
      next: (cities) => (this.cities = cities),
    });
  }

  obtenerLocalidades(event: any) {
    const localidades: any = [];
    const comunaArr = event.id.split('@');
    const comunas = this.cities.filter(
      (comuna) => comuna.city == comunaArr[0]
    );
    comunas.map((comuna) =>
      comuna.localities.map((localidad: any) => localidades.push(localidad))
    );
    this.localidades = localidades;
  }

  geolocalizacion(event: any) {
    this.formDireccion.controls['latitud'].setValue(event.lat);
    this.formDireccion.controls['longitud'].setValue(event.lng);
  }

  clearAddress() {
    this.formDireccion.setValue({
      calle: '',
      depto: null,
      numero: '',
      comuna: null,
      localizacion: '',
      referencia: '',
      latitud: '',
      longitud: '',
    });
  }

  // Funciones direccion Peru

  private getDepartamento() {
    this.geolocationApiService.getListaDepartamentos().subscribe({
      next: (data: any) => (this.departamento = data),
    });
  }

  onSelectDepartamento(event: any) {
    this.geolocationApiService.getListaProvincia(event.codigo).subscribe({
      next: (data: any) => (this.provincia = data),
    });
  }

  onSelectProvincia(event: any) {
    this.geolocationApiService.getListaDistrito(event.codigo).subscribe({
      next: (data: any) => (this.distrito = data),
    });
  }

  selecionarDistrito(event: any) {
    this.codigoDistrito = event.codigo;
  }
}
